<script>
// CommitChart.js
import { Bar } from 'vue-chartjs'
import ChartDataLabels from "chartjs-plugin-labels";

Chart.plugins.unregister(ChartDataLabels);

export default {
    extends: Bar,
    props: {
        chartData: {
            type: Object,
            required: true
        },
        options: {
            type: String,
        }
    },
    mounted () {
        const options = Object.assign({}, JSON.parse(this.options))
        this.addPlugin(ChartDataLabels);
        this.renderChart(this.chartData, options)
    }
}

</script>
